import { helpArticles } from '@/shared/constants/help-articles'

export default {
  data: function () {
    return {
      helpArticles: helpArticles,
      activeTooltip: null,
    }
  },
  methods: {
    openHelpUrl: function (url) {
      window.open(url, '_blank', 'noopener,noreferrer')
    },
    handleTooltipToggle: function (isOpen, id) {
      // Ensure only one tooltip stays open at a time
      this.activeTooltip = isOpen ? id : (this.activeTooltip === id ? null : this.activeTooltip)
    },
    isTooltipActive: function (id) {
      return this.activeTooltip === id
    }
  },
}
